const GetSPGlobalPageFilterReducer = (state = { type: 'LOADING_SPGLOBAL_PAGE_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_PAGE_FILTER_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_PAGE_FILTER_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_PAGE_FILTER_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_PAGE_FILTER_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_PAGE_FILTER_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_PAGE_FILTER_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSPGlobalPageLabelCountReducer = (state = { type: 'LOADING_SPGLOBAL_PAGE_LABEL_COUNT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_PAGE_LABEL_COUNT_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_PAGE_LABEL_COUNT_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_PAGE_LABEL_COUNT_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_PAGE_LABEL_COUNT_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_PAGE_LABEL_COUNT_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_PAGE_LABEL_COUNT_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSPGlobalLineChartReducer = (state = { type: 'LOADING_SPGLOBAL_LINE_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_LINE_CHART_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_LINE_CHART_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_LINE_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_LINE_CHART_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_LINE_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_LINE_CHART_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSPGlobalTableReducer = (state = { type: 'LOADING_SPGLOBAL_TABLE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_TABLE_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_TABLE_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_TABLE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_TABLE_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_TABLE_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_TABLE_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSPGlobalDateReducer = (state = { type: 'LOADING_SPGLOBAL_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_DATE_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_DATE_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_DATE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_DATE_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_DATE_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_DATE_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

const GetSPGlobalDetailReportReducer = (state = { type: 'LOADING_SPGLOBAL_DETAIL_REPORT_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_SPGLOBAL_DETAIL_REPORT_ACTION':
            return { ...state, type: 'LOADING_SPGLOBAL_DETAIL_REPORT_ACTION', loading: true };
        case 'SUCCESS_SPGLOBAL_DETAIL_REPORT_ACTION':
            return { ...action, loading: false };
        case 'ERROR_SPGLOBAL_DETAIL_REPORT_ACTION':
            return { ...state, type: 'ERROR_SPGLOBAL_DETAIL_REPORT_ACTION', loading: false, error: action.error };
        case 'RESET_SPGLOBAL_DETAIL_REPORT_ACTION':
            return { type: action.payload, data: {} };
        default:
            return state;
    }
};

export {
    GetSPGlobalPageLabelCountReducer,
    GetSPGlobalPageFilterReducer,
    GetSPGlobalLineChartReducer,
    GetSPGlobalTableReducer,
    GetSPGlobalDateReducer,
    GetSPGlobalDetailReportReducer,
};
